import { render } from "./PayAudioPlayerEditModal.vue?vue&type=template&id=9910f3c2&scoped=true"
import script from "./PayAudioPlayerEditModal.vue?vue&type=script&lang=js"
export * from "./PayAudioPlayerEditModal.vue?vue&type=script&lang=js"

import "./PayAudioPlayerEditModal.vue?vue&type=style&index=0&id=9910f3c2&scoped=true&lang=less"
import "./PayAudioPlayerEditModal.vue?vue&type=style&index=1&id=9910f3c2&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9910f3c2"]])

export default __exports__